import { useEffect, useState } from 'react';
import { getOwnStudentRecord } from '../../StudentRecord/services/studentRecordService';

export function useOwnStudentRecord() {
  const [student, setStudent] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [grades, setGrades] = useState({});
  const [attendance, setAttendance] = useState([]);
  const [attendanceError, setAttendanceError] = useState('');
  const [attentionReviews, setAttentionReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError('');

    getOwnStudentRecord()
      .then((result) => {
        if (!mounted) return;
        if (!result) {
          setError('No student record is linked to this account.');
          setStudent(null);
          setSubjects([]);
          setGrades({});
          setAttendance([]);
          setAttentionReviews([]);
        } else {
          setStudent(result.student);
          setSubjects(result.subjects);
          setGrades(result.grades);
          setAttendance(result.attendance);
          setAttendanceError(result.attendanceError);
          setAttentionReviews(result.attentionReviews);
        }
      })
      .catch((err) => {
        if (mounted) setError(err.message || 'Failed to load your grades');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);

  return { student, subjects, grades, attendance, attendanceError, attentionReviews, loading, error };
}
